import classNames from "classnames";
import React from "react";

interface Props
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  src: string;
}

const AsyncImage = (props: Props) => {
  const [hasLoaded, setLoaded] = React.useState(false);
  const { src, ...rest } = props;

  React.useEffect(() => {
    let isMounted = true;

    const image = new Image();
    image.src = src;
    image.onload = () => (isMounted ? setLoaded(true) : null);

    return () => {
      isMounted = false;
    };
  }, [src]);

  return (
    <div
      {...rest}
      className={classNames("AsyncImage", props.className)}
      style={{
        ...rest.style,
        backgroundImage: `url("${props.src}")`,
        transition: "opacity 500ms ease",
        opacity: hasLoaded ? 1 : 0,
      }}
    />
  );
};

export default React.memo(AsyncImage);
